module.exports = __webpack_public_path__ + "img/noPortrait@2x.db9e7f0d.png";